import React from 'react';
import Layout from '../components/Layout';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <Layout>
      <div className="about-us-page">
        <div className="about-hero">
          <div className="about-hero-content">
            <h1>About FM Ultratech Farms</h1>
            <p>Your Trusted Partner in Modern Agriculture</p>
          </div>
        </div>

        <div className="about-content">
          <div className="about-container">
            <section className="about-section">
              <h2>Our Mission</h2>
              <p>
                Our mission is to empower farmers and agribusinesses in Nigeria with practical, modern, and cost-effective agricultural solutions that increase productivity, reduce losses, and improve profitability.
              </p>
              <p>
                We achieve this by combining hands-on farming experience, quality agricultural inputs, smart farming techniques, and market-driven advisory services that deliver real, measurable results on the farm.
              </p>
            </section>

            <section className="about-section">
              <h2>Our Vision</h2>
              <p>
                Our vision is to become a trusted leader in smart agriculture and agribusiness development in Nigeria and West Africa, connecting farmers to modern production systems, reliable inputs, and profitable local and export markets.
              </p>
              <p>
                We envision a future where Nigerian farmers farm efficiently, sustainably, and profitably, using technology, knowledge, and structured market access rather than guesswork.
              </p>
            </section>

            <section className="about-section">
              <h2>Why Choose Us</h2>
              <div className="features-grid">
                <div className="feature-card">
                  <div className="feature-icon">✓</div>
                  <h3>We Farm What We Teach</h3>
                  <p>We operate our own farms, so our recommendations are based on real field experience, not theory. Every solution we offer has been tested under Nigerian farming conditions.</p>
                </div>
                <div className="feature-card">
                  <div className="feature-icon">✓</div>
                  <h3>Practical, Cost-Effective Solutions</h3>
                  <p>We focus on solutions that work, not expensive trial-and-error methods. Our goal is to help farmers maximize yield and profit while controlling costs.</p>
                </div>
                <div className="feature-card">
                  <div className="feature-icon">✓</div>
                  <h3>Quality Inputs from Trusted Sources</h3>
                  <p>We supply greenhouse and agricultural accessories sourced from reliable manufacturers, including direct partners in China, ensuring quality, durability, and fair pricing.</p>
                </div>
                <div className="feature-card">
                  <div className="feature-icon">✓</div>
                  <h3>End-to-End Support</h3>
                  <p>From nursery services (bell pepper, habanero, and other crops) to farm setup, crop management, pest control, and market linkage, we provide complete support across the farming value chain.</p>
                </div>
                <div className="feature-card">
                  <div className="feature-icon">✓</div>
                  <h3>Market & Export Focus</h3>
                  <p>We help farmers grow crops that meet market and export standards, reducing post-harvest losses and improving access to higher-value buyers.</p>
                </div>
                <div className="feature-card">
                  <div className="feature-icon">✓</div>
                  <h3>Results-Driven Approach</h3>
                  <p>At FM Ultratech Farms, success is measured by better yields, lower losses, and higher farmer income—not promises.</p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AboutUs;
